<template>
  <div>
    <!-- Content -->
    <div class="">
      <p class="mb-md">
        Please enter the address of your primary warehouse
        or distribution center. We will start with one location,
        but you can always add more later.
      </p>
      <div>
        <AddressForm
          v-model="location"
          :addressForm="location"
          type="warehouse"
          addressNameLabel="Business Name"
          :errors="errors"
          :requireNickname="true"
          :requireAddressName="true"
          :requireEmail="true"
          :requirePhone="true"
          @is:ready="isReady"
        />
      </div>
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            size="is-medium"
            @click="goBack"
            expanded
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            size="is-medium"
            expanded
            :disabled="!isValidated || saving"
            :loading="saving"
            @click="goForward"
          >Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressForm from '@/components/Global/AddressForm'

export default {
  components: {
    AddressForm
  },
  computed: {
    ...mapGetters(['app', 'context'])
  },
  data () {
    return {
      location: null,
      saving: false,
      errors: {},
      isValidated: false
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'onboarding.tasks', params: { connection: this.connection.id } })
    },
    goForward () {
      const method = (this.location.id) ? 'patch' : 'post'
      const endpoint = (this.location.id)
        ? this.context.route + '/locations/' + this.location.id + '/'
        : this.context.route + '/locations/'
      this.saving = true
      this.$http[method](endpoint, this.location).then(response => {
        this.completeTask()
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
        this.saving = false
      })
    },
    completeTask () {
      const endpoint = this.context.route + '/assigned-tasks/' + this.$route.params.task + '/complete/'
      return this.$http.put(endpoint).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Task Completed!' })
        this.$router.push({ name: 'onboarding.tasks', params: { connection: this.connection.id } })
      })
    },
    isReady (val) {
      this.isValidated = val
    }
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    },
    existingLocation: {
      type: Object,
      default: null
    }
  },
  watch: {
    existingLocation: {
      handler (location) {
        if (location) {
          this.location = this.existingLocation
        }
      },
      // force eager callback execution
      immediate: true
    }
  }
}
</script>
